import { getConfig } from "./config";

/**
 * This is the actual wrapper code that calls Amazon & Prebid, get theirs bids, then sends that off to DFP. Has a timeout to ensure that DFP gets called if bids too take long.
 * Bidders that don't respond within the timeout don't get their bids counted.
 */
export async function fetchHeaderBids(
  apstagSlots: object[],
  adUnits: prebidUnit[],
  GAMSlots: object[]
) {
  const amazonUnitsPresent = !!apstagSlots.length;
  const prebidUnitsPresent = !!adUnits.length;
  const config = await getConfig();

  // Init prebid.
  window.pbjs = window.pbjs || {};
  let pbjs = window.pbjs;
  pbjs.que = pbjs.que || [];

  // Init APS.
  if (config.amazonEnabled && amazonUnitsPresent) {
    window.apstag.init(config.amazon);
  }

  let pConfig = config.prebid;

  if (typeof window.__tcfapi !== "function") {
    delete pConfig.consentManagement;
  }

  // Add config to Prebid
  pbjs.que.push(function () {
    pbjs.bidderSettings = {
      standard: {
        storageAllowed: true,
      },
    };
    pbjs.addAdUnits(adUnits);
    pbjs.setConfig(pConfig);
  });

  // Create a requestManager to keep track of bidder state to determine when to send ad server.
  // Request and what apstagSlots to request from the ad server.
  interface requestManager {
    [key: string]: any;
    adserverRequestSent: boolean;
    aps: boolean;
    prebid: boolean;
  }

  let requestManager: requestManager = {
    adserverRequestSent: false,
    aps: false,
    prebid: false,
  };

  function biddersBack() {
    if (requestManager.aps && requestManager.prebid) {
      sendAdserverRequest();
    }
    return;
  }

  function sendAdserverRequest() {
    if (requestManager.adserverRequestSent === true) {
      return;
    }

    requestManager.adserverRequestSent = true;

    window.googletag.cmd.push(function () {
      if (GAMSlots.length === 0) {
        window.googletag.pubads().refresh();
      } else {
        window.googletag.pubads().refresh(GAMSlots);
      }
    });
  }

  function requestHeaderBids() {
    if (config.amazonEnabled && amazonUnitsPresent) {
      // APS Request
      window.apstag.fetchBids(
        {
          slots: apstagSlots,
        },
        function (bids: any) {
          window.googletag.cmd.push(function () {
            window.apstag.setDisplayBids();
            requestManager.aps = true;
            biddersBack();
          });
        }
      );
    } else {
      requestManager.aps = true;
      biddersBack();
    }

    if (prebidUnitsPresent) {
      // Prebid Request
      pbjs.que.push(function () {
        pbjs.requestBids({
          bidsBackHandler: function () {
            window.googletag.cmd.push(function () {
              pbjs.setTargetingForGPTAsync();
              requestManager.prebid = true;
              biddersBack();
            });
          },
          timeout: config.prebid.timeout,
        });
      });
    } else {
      requestManager.prebid = true;
      biddersBack();
    }
  }

  requestHeaderBids();

  window.setTimeout(function () {
    sendAdserverRequest();
  }, config.globalTimeout);
}
